<div class="it-header-slim-wrapper" [ngClass]="{'cc': userService.isCallCenterUser()}">
  <div class="container-fluid">
    <div class="row">
      <div class="col-12">
        <div class="it-header-slim-wrapper-content">
          <div class="it-brand-wrapper">
            <a href="#">
              <div class="d-block navbar-brand">
                <img src="https://assets.infocert.it/logos/products/ipp/extended/white.svg" class="img-fluid brand-image" alt="Logo">
              </div>
            </a>
          </div>
          <div class="it-header-block-title font-weight-bold white-color">InfoCert Partner Platform<span
              class="it-header-block-title font-weight-bold white-color"
              *ngIf="userService.activeRole === UserPrimaryRoleConstants.OCC">&nbsp;- CallCenter</span></div>
          <div class="it-header-slim-right-zone">
            <div class="nav-item dropdown">
              <a class="nav-link dropdown-toggle" href="#" data-toggle="dropdown" aria-expanded="false">
                <span>{{translateService.currentLang}}</span>
                <svg class="icon d-none d-md-block">
                  <use xlink:href="/assets/svg/sprite.svg#it-expand"></use>
                </svg>
              </a>
              <div class="dropdown-menu">
                <div class="row">
                  <div class="col-12">
                    <div class="link-list-wrapper">
                      <ul class="link-list">
                        <li *ngFor="let lang of translateService.getLangs()">
                          <a class="list-item cursor-pointer" (click)="useLang(lang)"><span>{{
                              (lang | uppercase)}}</span></a>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <i class="fas fa-redo-alt fa-2x fa white-color p-1 cursor-pointer"
              [attr.title]="'LABEL.REFRESH' | translate" (click)="refreshPage()"></i>
            <div class="border h-75 ml-1 mr-1"></div>
            <i class="fas fa-cog fa-2x white-color p-1 cursor-pointer" [attr.title]="'LABEL.CONFIG' | translate"
              (click)="onSetting()"></i>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
